import { useState } from "react";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function GstLinkReport({ token, onApplied }) {
  const [rep, setRep] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (apply) => {
    if (apply && !window.confirm("Link ONLY the unambiguous payments listed? Ambiguous ones stay for manual review. No expense is created or changed.")) return;
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/gst/link-report`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, apply }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "Failed");
      setRep(d);
      if (apply) { toast.success("Unambiguous payments linked"); onApplied(); }
    } catch (e) { toast.error(e.message); }
    setBusy(false);
  };
  const autoCount = rep ? Object.values(rep.summary).reduce((a, s) => a + (s.auto_linkable || 0), 0) : 0;
  return (
    <Card data-testid="gst-link-report">
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-base">Existing GST expenses — link review (India, Super Admin)</CardTitle>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" onClick={() => run(false)} disabled={busy} data-testid="gst-report-run">{busy && <Loader2 className="w-3 h-3 mr-1 animate-spin" />}Review all GST expenses</Button>
          {rep && !rep.applied && autoCount > 0 && <Button size="sm" onClick={() => run(true)} disabled={busy} data-testid="gst-report-apply">Link {autoCount} unambiguous</Button>}
        </div>
      </CardHeader>
      {rep && (
        <CardContent className="space-y-3 text-xs">
          {Object.entries(rep.centers).map(([c, b]) => (
            <div key={c} className="border rounded p-2" data-testid={`gst-report-${c}`}>
              <b>{c}</b> — linked {b.linked.length} · auto-linkable {b.auto_linkable.length} · manual review {b.manual_review.length}
              {b.auto_linkable.map((e) => <div key={e.expense_id} className="text-green-800">✓ {e.date} ₹{e.amount} → {e.proposed_gst_month} ({e.reason})</div>)}
              {b.manual_review.map((e) => <div key={e.expense_id} className="text-amber-800">? {e.date} ₹{e.amount} “{e.description}” — {e.reason}; suggested {e.suggested_gst_month}. Use Link Payment on that month.</div>)}
            </div>
          ))}
          {!Object.keys(rep.centers).length && <p>No India GST expenses found.</p>}
        </CardContent>
      )}
    </Card>
  );
}
